import React from 'react';
import { Box } from '@mui/material';

const MainContent = ({ children, ...props }) => {
  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
        backgroundColor: (theme) =>
          theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[900],
        ...props.sx
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default MainContent;